import { Button, Dialog, DialogProps, Modal } from 'react-aria-components';
import { cn } from '~/lib/utils';
import {
  dialogCloseClassName,
  dialogContentClassName,
  dialogOverlayClassName,
  dialogPanelClassName,
} from './dialogStyles';
import Icon from './Icon';

export default function DialogComponent(
  props: DialogProps & { show?: boolean; onClose?: () => void; classNameDialog?: string },
) {
  return (
    <Modal
      isDismissable
      className={dialogOverlayClassName}
      isOpen={props.show}
      onOpenChange={props.onClose}
    >
      <Dialog {...props} className={dialogPanelClassName}>
        {(renderProps) => (
          <div className={cn(dialogContentClassName, props.className)}>
            <Button slot="close" aria-label="Close" className={dialogCloseClassName}>
              <Icon name="close" className="text-[20px]" />
            </Button>
            {typeof props.children === 'function' ? props.children(renderProps) : props.children}
          </div>
        )}
      </Dialog>
    </Modal>
  );
}
